import React, { useState } from 'react';
import { Popover } from 'antd';
import { LuInfo } from 'react-icons/lu';
import { IconType } from 'react-icons';

function ic(Icon: IconType, size = 16) {
  const C = Icon as React.ComponentType<{ size?: number }>;
  return <C size={size} />;
}

// ─────────────────────────────────────────────────────────────
// MapAttributionButton
// Replaces the hidden Mapbox attribution control with a custom
// info button at the bottom-right corner of the map.
// Matches the native @rnmapbox/maps attributionPosition behaviour
// on the mobile app (OpterraPhoenix).
//
// NOTE: Attribution links must remain visible per Mapbox ToS.
// ─────────────────────────────────────────────────────────────

const ATTRIBUTION_LINKS = [
  { label: '© Mapbox', url: 'https://www.mapbox.com/about/maps/' },
  { label: '© OpenStreetMap', url: 'https://www.openstreetmap.org/copyright' },
];

const popoverContent = (
  <div className="flex flex-col gap-1.5">
    {ATTRIBUTION_LINKS.map(({ label, url }) => (
      <a
        key={url}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-success-dark hover:underline"
      >
        {label}
      </a>
    ))}
  </div>
);

const MapAttributionButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="absolute bottom-2 right-2 z-10">
      <Popover
        content={popoverContent}
        trigger="click"
        open={open}
        onOpenChange={setOpen}
        placement="topLeft"
        arrow={{ pointAtCenter: true }}
      >
        <button
          type="button"
          aria-label="Map attribution"
          className="flex items-center justify-center bg-transparent p-0 border-0 text-success transition hover:opacity-70 cursor-pointer"
        >
          {ic(LuInfo, 18)}
        </button>
      </Popover>
    </div>
  );
};

export default MapAttributionButton;
